import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05dd371d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "price-detail van-hairline--top",
  id: "price-detail-wrap"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "保费明细", -1))
const _hoisted_3 = { class: "cell-wrap" }
const _hoisted_4 = {
  class: "cell",
  id: "countContentId"
}
const _hoisted_5 = { class: "line" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "应交保费", -1))
const _hoisted_7 = { class: "value hide-right-padding need-original-premium" }
const _hoisted_8 = {
  key: 0,
  class: "cell"
}
const _hoisted_9 = { class: "line" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "优惠权益", -1))
const _hoisted_11 = { class: "tag-wrap value" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "cell use-equity-tips"
}
const _hoisted_14 = {
  class: "cell",
  id: "tableContentId"
}
const _hoisted_15 = { class: "line" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "出险次数", -1))
const _hoisted_17 = { class: "expand-text-content" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "使用意外机损险保障额度抵扣维修费用则视为一次出险！", -1))
const _hoisted_19 = { class: "cell" }
const _hoisted_20 = { class: "line" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保险系数", -1))
const _hoisted_22 = { class: "expand-table-content" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 平安保险根据您在“意外机损保险”服务期限内的设备维修情况调整（上下浮动）次年增值服务/保险产品或一年内二次购买价格。 ", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "次年增值服务/保险产品系数参考如下：", -1))
const _hoisted_25 = { class: "table-wrap" }
const _hoisted_26 = {
  class: "table",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "head-tr" }, [
  /*#__PURE__*/_createElementVNode("th", null, "出险次数"),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("div", null, "保费系数"),
    /*#__PURE__*/_createElementVNode("div", null, "（基础保费下系数）")
  ])
], -1))
const _hoisted_28 = { class: "cell" }
const _hoisted_29 = { class: "line real-insurance-price" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "实付保费", -1))
const _hoisted_31 = { class: "value hide-right-padding" }

import { useCustomServiceInfo } from '@/compositions/insurance'
import { useInsuranceStore } from '@/compositions/insurance/index'
import { getJijiaInsuranceEquityOptions } from '@/defination/insurance'
import { ref, withDefaults, computed, nextTick } from 'vue'
import { DeviceJijiaInsuranceInfoProjectItem } from '@/types/insurance'


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-price-detail',
  props: {
    data: { default: () => null },
    cycleYear: { default: 1 },
    hasRightArrow: { type: Boolean, default: true },
    canUseEquity: { type: Boolean, default: false },
    useEquityValue: { default: '' },
    confirmUseEquity: { type: Boolean, default: false },
    isShowUbiInfo: { type: Boolean, default: false },
    currentInsurancePrice: null
  },
  emits: ['equityClickHandle'],
  setup(__props: any, { emit: emits }) {

const props = __props as { data: DeviceJijiaInsuranceInfoProjectItem | null, cycleYear: number, hasRightArrow: boolean, canUseEquity: boolean, useEquityValue: string, confirmUseEquity: boolean, isShowUbiInfo: boolean, currentInsurancePrice: number | string };

const { updatePriceDetailItemChangeKey } = useInsuranceStore()


const showCountContent = ref(false)
const showTableContent = ref(false)
const equityOptions = getJijiaInsuranceEquityOptions(false)
const { callHandle, phone } = useCustomServiceInfo()
// 判断是否为投保首周期
const isFirstYear = computed(() => props.cycleYear == 1)
const tableList = [
  { label: '0', value: '0.8' },
  { label: '1', value: '0.9' },
  { label: '0（但退保）', value: '1' },
  { label: '2', value: '1' },
  { label: '3', value: '1.1' },
  { label: '4', value: '1.3' },
  { label: '5-6', value: '1.5' },
  { label: '7及以上', value: '2' },
]
const activeIndex = computed(() => {
  let num = props.data?.danger_num || 0
  let rate = props.data?.interest_rate || 1
  if (num === 0) {
    return rate === 0.8 ? 0 : 2
  }
  if (num >= 7) {
    return 7
  }
  if (num === 5 || num === 6) {
    return 6
  }
  if (num === 1) {
    return 1
  }
  return num + 1
})

function toggleCountContentHandle() {
  showCountContent.value = !showCountContent.value
  if (showCountContent.value) {
    nextTick(() => {
      let el = document.getElementById('countContentId')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })
  }
  nextTick(() => {
    updatePriceDetailItemChangeKey()
  })
}
function toggleTableContentHandle() {
  showTableContent.value = !showTableContent.value
  if (showTableContent.value) {
    nextTick(() => {
      let el = document.getElementById('tableContentId')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  }
  nextTick(() => {
    updatePriceDetailItemChangeKey()
  })
}

function equityClickHandle(item: { label: string; value: string }) {
  emits('equityClickHandle', item)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, " ￥" + _toDisplayString(props.data?.original_premium), 1)
          ])
        ]),
        (props.canUseEquity)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(equityOptions), (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(__props.useEquityValue === item.value ? 'active' : ''),
                      key: item.value,
                      onClick: ($event: any) => (equityClickHandle(item))
                    }, _toDisplayString(item.label), 11, _hoisted_12))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (props.confirmUseEquity)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, " * 使用后或会影响退保权益，以官方发布信息为准。 "))
          : _createCommentVNode("", true),
        (props.isShowUbiInfo)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", {
                    class: "value",
                    onClick: toggleCountContentHandle
                  }, [
                    _createTextVNode(_toDisplayString(props.data?.danger_num || 0) + " 次", 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon-down", showCountContent.value ? 'icon-up' : ''])
                    }, null, 2)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_17, [
                  _createTextVNode(" 若设备维修单"),
                  _hoisted_18,
                  _createTextVNode(" 质保、付费或其他增值服务维修则不算出险。 ")
                ], 512), [
                  [_vShow, showCountContent.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", {
                    class: "value",
                    onClick: toggleTableContentHandle
                  }, [
                    _createTextVNode(_toDisplayString(props.data?.interest_rate), 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["icon-down", showTableContent.value ? 'icon-up' : ''])
                    }, null, 2)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _hoisted_24,
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("table", _hoisted_26, [
                      _hoisted_27,
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableList, (item, index) => {
                        return _createElementVNode("tr", {
                          key: index,
                          class: _normalizeClass(index === _unref(activeIndex) ? 'active-tr' : '')
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.label), 1),
                          _createElementVNode("td", null, _toDisplayString(item.value), 1)
                        ], 2)
                      }), 64))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode(" 以上系数信息不适用于一年内二次购买价格浮动系数。如您对价格有疑问，请致电 "),
                    _createElementVNode("span", {
                      class: "phone-number",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(callHandle) && _unref(callHandle)(...args)))
                    }, _toDisplayString(_unref(phone)), 1)
                  ])
                ], 512), [
                  [_vShow, showTableContent.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, "￥" + _toDisplayString(__props.currentInsurancePrice), 1)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})